// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --heatmapFadeIn-start-offset: 50%;
    --heatmapFadeIn-end-offset: 0%;
  }

.heatmapboxcontentpane {
    width: 100%;
    height: 100%;
    position: relative;
    /*overflow: hidden;*/
}
.heatmapboxcontentpane2 {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}
.heatmapbox {
    position: absolute;
    display: flex;
    font-size: 0.75rem;
    line-height: 0.75rem;
    cursor: pointer;
    border: 0.5px solid #fff;
    box-sizing: border-box;
    /* keep nested cells and long group titles inside their own cell */
    overflow: hidden;
}

.heatmapboxtopborder {
    border: 1px solid #fff;
}


.heatmapbox2 {
    position: absolute;
    border-style: solid;
    border-color: #ffffff;
    border-width: 0 1px 1px 0;
    box-sizing: border-box;
    display: flex;
    font-size: 0.75rem;
    line-height: 0.75rem;
}

.heatmapboxtitle {
    /*pointer-events: none;*/
    background-color: transparent;
    padding: 5px 2px;
    top: 0px;
    left: 0px;
    z-index: 100;
}
.heatmapboxtitletext {
    text-align: left;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
    color: #000000;
}

.heatmapboxlabel {
    /*background-color: #00000050;*/
    position: absolute;
    pointer-events: none;
    padding: 5px;
    top: 5px;
    left: 5px;
    right: 0px;
    z-index: 100;
}

.heatmapboxtext {
    font-size: 11px;
    text-align: left;
    color: #ffffff;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100%;
}


/* Heatmap Animation Styles */
.heatmap-animate {
    animation: heatmapFadeIn 0.5s ease-out forwards;
    opacity: 0;
    transform-origin: var(--heatmapFadeIn-start-offset) var(--heatmapFadeIn-end-offset);
}

@keyframes heatmapFadeIn {
    0% {
        opacity: 0;
        transform: scale(0);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.heatmapboxcontentpane2:hover {
    opacity: 0.99;
}

/*.heatmapbox:hover {
    opacity: 0.7;
}*/



 `, "",{"version":3,"sources":["webpack://./src/Components/Heatmap/Heatmap.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,8BAA8B;EAChC;;AAEF;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,wBAAwB;IACxB,sBAAsB;IACtB,kEAAkE;IAClE,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,gBAAgB;IAChB,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;;AAGA,6BAA6B;AAC7B;IACI,+CAA+C;IAC/C,UAAU;IACV,mFAAmF;AACvF;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;;EAEE","sourcesContent":[":root {\n    --heatmapFadeIn-start-offset: 50%;\n    --heatmapFadeIn-end-offset: 0%;\n  }\n\n.heatmapboxcontentpane {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    /*overflow: hidden;*/\n}\n.heatmapboxcontentpane2 {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n.heatmapbox {\n    position: absolute;\n    display: flex;\n    font-size: 0.75rem;\n    line-height: 0.75rem;\n    cursor: pointer;\n    border: 0.5px solid #fff;\n    box-sizing: border-box;\n    /* keep nested cells and long group titles inside their own cell */\n    overflow: hidden;\n}\n\n.heatmapboxtopborder {\n    border: 1px solid #fff;\n}\n\n\n.heatmapbox2 {\n    position: absolute;\n    border-style: solid;\n    border-color: #ffffff;\n    border-width: 0 1px 1px 0;\n    box-sizing: border-box;\n    display: flex;\n    font-size: 0.75rem;\n    line-height: 0.75rem;\n}\n\n.heatmapboxtitle {\n    /*pointer-events: none;*/\n    background-color: transparent;\n    padding: 5px 2px;\n    top: 0px;\n    left: 0px;\n    z-index: 100;\n}\n.heatmapboxtitletext {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    overflow: hidden;\n    font-size: 12px;\n    font-weight: bold;\n    line-height: 20px;\n    color: #000000;\n}\n\n.heatmapboxlabel {\n    /*background-color: #00000050;*/\n    position: absolute;\n    pointer-events: none;\n    padding: 5px;\n    top: 5px;\n    left: 5px;\n    right: 0px;\n    z-index: 100;\n}\n\n.heatmapboxtext {\n    font-size: 11px;\n    text-align: left;\n    color: #ffffff;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 100%;\n}\n\n\n/* Heatmap Animation Styles */\n.heatmap-animate {\n    animation: heatmapFadeIn 0.5s ease-out forwards;\n    opacity: 0;\n    transform-origin: var(--heatmapFadeIn-start-offset) var(--heatmapFadeIn-end-offset);\n}\n\n@keyframes heatmapFadeIn {\n    0% {\n        opacity: 0;\n        transform: scale(0);\n    }\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.heatmapboxcontentpane2:hover {\n    opacity: 0.99;\n}\n\n/*.heatmapbox:hover {\n    opacity: 0.7;\n}*/\n\n\n\n "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
